<template>
  <div class="page">
    <div class="page_contents">
      <div class="contents_div">
        <div class="page_header">자료실</div>
        <div class="detail_div">
          <div class="notice_header_div">
            <div class="notice_title">{{ resourceBoardData.제목 }}</div>
            <div class="notice_date">{{ convertDate(resourceBoardData.등록일시) }}</div>
            <div class="notice_hits">조회 {{ resourceBoardData.조회수 }}</div>
          </div>
          <div class="notice_contents" v-html="resourceBoardData.내용"></div>
          <!-- {{ resourceBoardData.내용 }} -->

          <div class="notice_file_list" v-if="resourceBoardData.첨부파일목록?.length != 0">
            <div class="notice_file_div" v-for="(file, index) in resourceBoardData.첨부파일목록" :key="index">
              <img src="@/assets/images/file_icon.png" />
              <div class="notice_file_link" @click="getFile(resourceBoardData.자료순번, file.저장순번, file.원파일명)">{{ file.원파일명 }}</div>
            </div>
          </div>
          <div class="notice_btn_div"><div class="back_btn" @click="goPage()">목록으로</div></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue";
import resourceBoardAPI from "../api/resourceBoardAPI";
import { useRouter } from "vue-router";
import { ApiResponse, ResourceBoard, ResourceBoardFile, Member } from "../common/types";
import { convertDate } from "../utils/utils";
const router = useRouter();
const resourceBoardData = ref<ResourceBoard>({
  자료순번: 0,
  제목: "",
  조회수: 0,
  내용: "",
  노출여부: "",
  작성자: {} as Member,
  등록자: "",
  등록일시: "",
  수정자: "",
  수정일시: "",
  첨부파일목록: [] as ResourceBoardFile[],
});
onMounted(() => {
  getDetail();
});
const getDetail = () => {
  const seq = Number(router.currentRoute.value.params.seq);
  resourceBoardAPI.getResourceBoard(seq).then((res) => {
    resourceBoardData.value = res.data.data;
  });
};

const getFile = (자료순번: number, 저장순번: number, 파일명: string) => {
  resourceBoardAPI.downloadResourceBoardFile(자료순번, 저장순번, 파일명);
};

// downloadDownloadboardFile(seq: number, index: number, filename: string) {
//         return axiosInstance.get(`/api/anonymous/noticeboards/${seq}/files/${index}`, {
//             responseType: 'blob'
//         }).then((response: any) => {
//             const url = window.URL.createObjectURL(new Blob([response]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', filename); // You can set the file name here
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         });
//     }

const goPage = () => {
  router.go(-1);
};
</script>
<style scoped>
.page_header {
  padding: 40px 0px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 38px;
  display: flex;
  gap: 16px;
  align-items: center;
  line-height: 51px;
  justify-content: center;
}
.page_contents {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-bottom: 100px;
  align-items: center;
}
.contents_div {
  width: 1010px;
}
.detail_div {
  border-top: 3px solid #041e42;
}
.notice_header_div {
  height: 87px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  /* gap: 50px; */
}
.notice_title {
  width: 100%;
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #272727;
}
.notice_date {
  color: #9b9b9b;
  font-size: 16px;
  min-width: 91px;
  text-align: right;
}
.notice_hits {
  color: #9b9b9b;
  font-size: 16px;
  min-width: 110px;
  text-align: right;
}
.notice_contents {
  padding: 30px 0px;
  min-height: 150px;
}
.notice_file_list {
  display: flex;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.notice_file_div {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
}
.notice_file_link {
  font-size: 16px;
  color: #0078db;
  cursor: pointer;
  border-bottom: 1px solid #0078db;
}
.notice_btn_div {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.back_btn {
  border: 1px solid #bcbcbc;
  width: 247px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 20px;
  color: #272727;
  cursor: pointer;
}
</style>
